import { render, staticRenderFns } from "./GuestFormIdReader.vue?vue&type=template&id=54071e32&scoped=true&"
import script from "./GuestFormIdReader.vue?vue&type=script&lang=js&"
export * from "./GuestFormIdReader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54071e32",
  null
  
)

export default component.exports